import { useRouter } from "next/router";
import { useCallback } from "react";

import { useAppSnackbar } from "@/custom-hooks/use-app-snackbar";
import { isIncompletePath } from "@/utils/common-utils";

import { LocalForageKeys } from "@/constants/local-forage-keys";
import { currentPartnerAtom } from "@/global-states/api-atoms";
import { authTokenInfoAtom, loadingAtom } from "@/global-states/common-atoms";
import { useAtom, useSetAtom } from "jotai";
import localforage from "localforage";

export const useApiConfig = () => {
  const router = useRouter();
  const { setAppSnackbar } = useAppSnackbar();

  const setLoading = useSetAtom(loadingAtom);
  const setCurrentPartner = useSetAtom(currentPartnerAtom);
  const [authTokenInfo, setAuthTokenInfo] = useAtom(authTokenInfoAtom);

  const catchApiError = useCallback((err: any) => {
    console.error(err);
    const baseMessage = "一時的なエラーが発生しました。しばらくしてから再度お試しください。";
    const devMessage = err?.response?.data?.dev_message || err?.message || "";
    const message = err?.response?.data?.message || `${baseMessage} ${devMessage ? `[${devMessage}]` : ""}`;
    setAppSnackbar(message, { error: true });
  }, []);

  const resetAuth = useCallback(async () => {
    if (isIncompletePath(router.asPath)) {
      return;
    }
    setCurrentPartner(null);
    setAuthTokenInfo(undefined);
    setLoading(false);
    await localforage.removeItem(LocalForageKeys.auth.AccessToken);
    await localforage.removeItem(LocalForageKeys.auth.RefreshToken);
  }, [router.asPath]);

  const getRefreshToken = useCallback(async (): Promise<string> => {
    const refreshToken = await localforage.getItem<string>(LocalForageKeys.auth.RefreshToken);
    if (typeof refreshToken === "string") {
      return refreshToken;
    } else {
      await resetAuth();
      return "";
    }
  }, []);

  return {
    catchApiError: catchApiError,
    resetAuth: resetAuth,
    getRefreshToken: getRefreshToken,
  };
};
